import {createTheme} from '@mui/material';
import {esES} from '@mui/material/locale';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createTheme(
   {
      palette,
      typography,
      components: {
         ...overrides,
         MuiTextField: {
            defaultProps: {
               size: 'small'
            }
         },
         MuiSelect: {
            defaultProps: {
               size: 'small'
            }
         }
      },
      zIndex: {appBar: 1200, drawer: 1100}
   },
   esES
);

export default theme;
